import React from "react"

const CommissionRatesContext = React.createContext({})

const { Provider, Consumer } = CommissionRatesContext

export { Provider, Consumer, CommissionRatesContext }
